import { create } from "zustand";

interface TouchMoveState {
  /** Task id currently being long-press-moved on a touch device, if any. The
   *  source block dims itself while it equals this so the live ghost (the thing
   *  the finger drags) isn't doubled by the still-painted original. */
  movingId: string | null;
  setMoving: (id: string | null) => void;
}

export const useTouchMoveStore = create<TouchMoveState>((set) => ({
  movingId: null,
  setMoving: (movingId) => set({ movingId }),
}));
